import Role from '@/constants/enums/Role';
import Permissao from '@/constants/enums/PermissoesPadrao';


export interface IMenuItem {
  name: string;
  params?: any;
  path: string;
  label: string;
  icon?: string;
  children: Array<IMenuItem>;
  relatedRoutes?: Array<string>;
  roles: Array<string>;
  permissions: Array<string>;
}

const items: Array<IMenuItem> = [
  {
    name: 'home',
    path: '/home',
    label: 'Home',
    icon: 'mdi-home',
    roles: [
      Role.Admin,
      Role.Assistencia,
      Role.Host,
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.Administrador,
      Role.AdminMedico,

    ],
    permissions: [],
    children: [],
  },
  {
    name: 'clinicas',
    path: '/clinicas',
    label: 'Clínicas',
    icon: 'mdi-hospital-box-outline',
    relatedRoutes: [
      'clinicasForm',
      'clinicasFormUpdate',
      'clinicasFormView',
    ],
    roles: [
      Role.Host,
    ],
    permissions: [Permissao.TenantRead],
    children: [],
  },
  {
    name: 'Agenda',
    path: '/agenda',
    label: 'Agendas',
    icon: '$calendar',
    roles: [
      Role.Admin,
      Role.Administrador,
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.AdminMedico,
    ],
    permissions: [Permissao.AgendaRead],
    children: [],
  },
  {
    name: 'atendimentos',
    path: '/',
    label: 'Atendimento',
    icon: '$briefcase',
    relatedRoutes: [
      'atendimentoForm',
      'atendimentoFormUpdate',
    ],
    roles: [
      Role.Medico,
      Role.AdminMedico,
      Role.Enfermeiro,
    ],
    permissions: [],
    children: [{
      name: 'atendimento',
      path: '/atendimentos',
      label: 'Atendimento',
      relatedRoutes: [
        'atendimentoForm',
        'atendimentoFormUpdate',
      ],
      roles: [
        Role.Medico,
        Role.AdminMedico,
      ],
      permissions: [Permissao.PacienteRead],
      children: [],
    },
    {
      name: 'imunizacao',
      path: '/imunizacao',
      label: 'Imunização',
      relatedRoutes: [
        'cartaoVacinas',
      ],
      roles: [
        Role.Medico,
        Role.AdminMedico,
        Role.Enfermeiro,
        Role.TecEnfermagem,
      ],
      permissions: [Permissao.PacienteRead],
      children: [],
    },
    {
      name: 'revisoes',
      path: '/revisoes',
      label: 'Revisão',
      relatedRoutes: [
        'atendimentoRevisaoFormView',
      ],
      roles: [
        Role.Medico,
        Role.AdminMedico,
        Role.Enfermeiro,
      ],
      permissions: [Permissao.PacienteRead],
      children: [],
    },
    ],
  },
  {
    name: 'Cadastros',
    path: '/cadastros',
    label: 'Cadastros',
    icon: '$documentAdd',
    roles: [
      Role.Admin,
      Role.Assistencia,
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.Administrador,
      Role.AdminMedico,
    ],
    permissions: [],
    children: [
      {
        name: 'pacientes',
        path: '/pacientes',
        label: 'Pacientes',
        relatedRoutes: [
          'pacientesForm',
          'pacientesFormUpdate',
          'pacientesFormView',
        ],
        roles: [
          Role.Medico,
          Role.Secretario,
          Role.TecEnfermagem,
          Role.Enfermeiro,
          Role.AdminMedico,
        ],
        permissions: [Permissao.PacienteRead],
        children: [],
      },
      {
        name: 'convenios',
        path: '/convenios',
        label: 'Convênios',
        relatedRoutes: [
          'conveniosForm',
          'conveniosFormUpdate',
          'conveniosFormView',
        ],
        roles: [
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Secretario,
          Role.TecEnfermagem,
          Role.Enfermeiro,
          Role.Administrador,
          Role.AdminMedico,

        ],
        permissions: [Permissao.ConvenioRead],
        children: [],
      },
    ],
  },
  {
    name: 'relatorios',
    path: '/relatorios',
    label: 'Relatórios',
    icon: '$reportBox',
    roles: [
      Role.Admin,
      Role.Assistencia,
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.Administrador,
      Role.AdminMedico,
    ],
    permissions: [],
    children: [
      {
        name: 'logsAuditoria',
        path: '/logs-auditoria',
        label: 'Auditoria',
        roles: [
          Role.Host,
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Secretario,
          Role.Enfermeiro,
          Role.TecEnfermagem,
          Role.Administrador,
          Role.AdminMedico,
        ],
        relatedRoutes: [
          'logsAuditoria',
        ],
        permissions: [Permissao.AuditoriaRead],
        children: [],
      },
    ],
  },
  {
    name: 'triagens',
    path: '/',
    label: 'Triagem',
    icon: '$clinical',
    roles: [
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.AdminMedico,
    ],
    permissions: [],
    children: [
      {
        name: 'triagens',
        path: '/triagens',
        label: 'Triagem',
        relatedRoutes: [
          'triagens',
        ],
        roles: [
          Role.Medico,
          Role.Secretario,
          Role.Enfermeiro,
          Role.TecEnfermagem,
          Role.AdminMedico,
        ],
        permissions: [Permissao.TriagemReadAll],
        children: [],
      },
    ],
  },
  {
    name: 'configuracoes',
    path: '/configuracoes',
    label: 'Configurações',
    icon: '$displaySettings',
    roles: [
      Role.Admin,
      Role.Assistencia,
      Role.Medico,
      Role.Secretario,
      Role.TecEnfermagem,
      Role.Enfermeiro,
      Role.Administrador,
      Role.AdminMedico,
    ],
    permissions: [],
    children: [
      {
        name: 'usuarios',
        path: '/usuarios',
        label: 'Usuarios',
        relatedRoutes: [
          'usuario',
          'visualizarUsuario',
        ],
        roles: [
          Role.Admin,
          Role.Assistencia,
          Role.Administrador,
          Role.AdminMedico,
        ],
        permissions: [Permissao.UsuarioRead],
        children: [],
      },
      {
        name: 'impressosPersonalizados',
        path: '/impressos-personalizados',
        label: 'Impressos',
        roles: [
          Role.Host,
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Enfermeiro,
          Role.Administrador,
          Role.AdminMedico,
        ],
        relatedRoutes: [
          'impressosPersonalizados',
          'impressosPersonalizadosFormUpdate',
        ],
        permissions: [Permissao.ImpressoPersonalizadoRead],
        children: [],
      },
      {
        name: 'configuracoesTiposDeConsultaView',
        path: '/configuracoes/tipos-de-consulta',
        label: 'Tipos de Consultas',
        relatedRoutes: [
          'configuracoesTiposDeConsultaView',
        ],
        roles: [
          Role.Medico,
          Role.Secretario,
          Role.Enfermeiro,
          Role.TecEnfermagem,
          Role.AdminMedico,

        ],
        permissions: [],
        children: [],
      },
      {
        name: 'configuracoesQuadrosPersonalizadosView',
        path: '/configuracoes/quadros-personalizados',
        label: 'Quadros',
        relatedRoutes: [
          'configuracoesQuadrosPersonalizadosView',
        ],
        roles: [
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Secretario,
          Role.Enfermeiro,
          Role.Administrador,
          Role.TecEnfermagem,
          Role.AdminMedico,
        ],
        permissions: [],
        children: [],
      },
      /* Esse trecho foi comentado, pois futuramente será implementado as consultas e quadros personalizados e essa rota será utilizadas
      {
        name: 'consultasPersonalizadas',
        path: '/consultas-personalizadas',
        label: 'Consultas',
        relatedRoutes: [
          'consultaPersonalizadaForm',
        ],
        roles: [
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Enfermeiro,
          Role.Administrador,

        ],
        permissions: [],
        children: [],
      },
      {
        name: 'quadrosCustomizados',
        path: '/quadros-customizados',
        label: 'Quadros',
        relatedRoutes: [
          'quadrosCustomizadosForm',
        ],
        roles: [
          Role.Admin,
          Role.Assistencia,
          Role.Medico,
          Role.Enfermeiro,
          Role.Administrador,

        ],
        permissions: [],
        children: [],
      }, */
    ],
  },
  {
    name: 'importacao',
    path: '/importacao',
    label: 'importacao',
    icon: 'mdi-file-document-outline',
    roles: [
      Role.Host,

    ],
    permissions: [],
    children: [],
  },
  {
    name: 'campanhas',
    path: '/campanhas',
    label: 'campanhas',
    icon: 'mdi-account-voice',
    roles: [
      Role.Host,
    ],
    permissions: [],
    children: [],
  },
];

export default items;
